import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';

interface IProps {
    customerId: string;
    isAddMoneyFlow: boolean | null;
}

interface IError {
    content: string;
    isDismissable: boolean;
}

interface IRsponse {
    maxAllowedAmount: number;
    whiteListList: [];
}

const nonDismissibleErrorCodes = [41191, 4085, 41193];

export const useAchInLimitQuery = ({ customerId, isAddMoneyFlow }: IProps, onSuccess: (amount: number) => void, onError: (e: IError) => void) => useQuery(
  'ach-in-limit',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/ach/${isAddMoneyFlow ? '' : 'out/'}limits`);
    return data;
  },
  {
    enabled: false,
    retry: 1,
    onSuccess: (res:IRsponse) => onSuccess(res.maxAllowedAmount),
    onError: (_e: IServerErrorResponse) => {
      const errData = _e.response.data.errors[0];
      const errCode = errData.code;
      const errContent = errData.localizedMessage;
      const isDismissable = !nonDismissibleErrorCodes.includes(errCode);
      onError({ content: errContent, isDismissable });
    },
  },
);
